module.exports = __webpack_public_path__ + "img/theme1.6f16916d.png";